import React, { useContext } from 'react'
import { RemoteComponent } from '../../legacy-design-system/remote-component/remote-component'
import { RouteContext } from '../route-provider'
import { useIntl } from 'react-intl'

export const ScansApplication = () => {
  const { organizationID } = useContext(RouteContext)
  const { locale } = useIntl()

  return (
    <RemoteComponent
      src={`${process.env.SAST_UI_SRC}/remoteEntry.js`}
      scope="sast_ui"
      module="./ScanApp"
      basename={`/${organizationID}/scans`}
      orgId={`${organizationID}`}
      locale={locale}
      sastUiSrc={process.env.SAST_UI_SRC}
      data-testid="scans-application"
    />
  )
}
